import React from 'react'
import { GridDrilldownPanel } from '../../../legacy-design-system/grid-drilldown-panel'
import { CsExternalLinkIcon } from '../../../legacy-design-system/icons'

export function AttackEventsGridDrilldownPanel({
  isOpen,
  organizationID,
  eventUuid,
  onClose,
  renderBody
}: {
  readonly isOpen: boolean
  readonly organizationID: string
  readonly eventUuid?: string
  readonly onClose: () => void
  readonly renderBody: () => any
}) {
  return (
    <GridDrilldownPanel
      isOpen={isOpen}
      yOffset={50}
      onClose={onClose}
      renderBody={renderBody}
      renderPanelActions={({ actionsIconCss }) => (
        <CsExternalLinkIcon
          size={16}
          onClick={() =>
            window.open(`#/${organizationID}/attacks/events/${eventUuid}`)
          }
          className={actionsIconCss}
        />
      )}
    />
  )
}
